import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/survey.css';

function SurveyTransition() {
  return (
    <div className="transition-container">
      <div className="transition-content">
        <div className="success-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
        </div>
        
        <h1>Questionnaire Complete!</h1>
        <p className="subtitle">Thanks for sharing your preferences with us.</p>
        
        <div className="info-card">
          <h2>One More Step to Your Personalized Experience</h2>
          <p>Based on your responses, we've crafted a custom EQ assessment just for you. This brief, interactive test will:</p>
          
          <ul className="benefits-list">
            <li>
              <span className="icon">🎯</span>
              <span>Present realistic social scenarios tailored to your background</span>
            </li>
            <li>
              <span className="icon">📊</span>
              <span>Measure your emotional intelligence in practical situations</span>
            </li>
            <li>
              <span className="icon">📝</span>
              <span>Generate a comprehensive personal EQ analysis report</span>
            </li>
            <li>
              <span className="icon">🎁</span>
              <span>Unlock four premium social scenarios customized for your needs</span>
            </li>
          </ul>
          
          <div className="time-estimate">
            <span className="clock-icon">⏱️</span>
            <span>Takes just 5-10 minutes to complete</span>
          </div>
        </div>
        
        <Link to="/custom-test" className="start-test-button">
          Start My Customized Assessment
        </Link>
        
        <p className="privacy-note">
          Your results are private and will only be used to enhance your experience.
        </p>
      </div>
    </div>
  );
}

export default SurveyTransition; 